export const applyBlackWhiteMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? '흑백 모드 적용 중 (1/3) - 색상 변환...' : 'Applying Black & White Mode (1/3) - Converting colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 흑백 모드 효과 적용
  // 1. 흑백 변환 (Canon 카메라 스타일)
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  for (let i = 0; i < data.length; i += 4) {
    // Canon 카메라의 흑백 필터에서 사용하는 가중치
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // 각 색상 채널의 가중치 조정 (Canon의 흑백 필터 시뮬레이션)
    const gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);
    
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 콘트라스트 조정
  setMessage(language === 'KR' ? '흑백 모드 적용 중 (2/3) - 콘트라스트 조정...' : 'Applying Black & White Mode (2/3) - Adjusting contrast...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const contrastData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const contrastPixels = contrastData.data;
  
  // 콘트라스트 증가
  const factor = 1.3; // 콘트라스트 강도
  
  for (let i = 0; i < contrastPixels.length; i += 4) {
    for (let c = 0; c < 3; c++) {
      const value = contrastPixels[i + c];
      contrastPixels[i + c] = Math.min(255, Math.max(0, 
        128 + factor * (value - 128)));
    }
  }
  
  ctx.putImageData(contrastData, 0, 0);
  
  // 3. 그레인 효과 추가 (필름 질감)
  setMessage(language === 'KR' ? '흑백 모드 적용 중 (3/3) - 필름 질감 추가...' : 'Applying Black & White Mode (3/3) - Adding film grain...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const grainData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const grainPixels = grainData.data;
  
  // 그레인 효과 추가
  for (let i = 0; i < grainPixels.length; i += 4) {
    if (Math.random() > 0.97) { // 3% 확률로 그레인 적용
      const grainAmount = (Math.random() - 0.5) * 30; // -15에서 15 사이의 그레인 강도
      
      for (let c = 0; c < 3; c++) {
        grainPixels[i + c] = Math.min(255, Math.max(0, grainPixels[i + c] + grainAmount));
      }
    }
  }
  
  ctx.putImageData(grainData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? '흑백 모드 적용 완료!' : 'Black & White Mode applied!');
};